import React, { useState } from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';

import SpreadingScheduleTable, {
  SpreadingScheduleTableProps,
} from './SpreadingScheduleTable';

export type SpreadingScheduleModalProps = Pick<
  ModalProps,
  'onCancel' | 'visible'
> &
  SpreadingScheduleTableProps & {
    controller?: React.ReactElement;
  };

const SpreadingScheduleModal = ({
  financialSchedule = [],
  controller,
  onCancel: onCancelProp,
  visible: visibleProp,
  ...otherProps
}: SpreadingScheduleModalProps) => {
  const [visible, setVisible] = useState(false);

  return (<>
    {controller &&
      React.cloneElement(controller, { onClick: () => setVisible(true) })}
    <Modal
      title="Spreading schedule"
      footer={null}
      width={1200}
      style={{ top: '20px', height: '400px' }}
      open={controller ? visible : visibleProp}
      onCancel={controller ? () => setVisible(false) : onCancelProp}
      {...otherProps}
    >
      <SpreadingScheduleTable financialSchedule={financialSchedule} />
    </Modal>
  </>);
};

export default SpreadingScheduleModal;
